module.exports = __webpack_public_path__ + "static/media/conf-app3.1c749cdd.png";